/* eslint-disable react/jsx-props-no-spreading */
import Icon from "../Icon";

const AtRegularV6 = (props) => (
  <Icon {...props} name="At Regular V6">
    <path d="M8.231.504a7.421 7.421 0 0 0-5.44 2.111A7.49 7.49 0 0 0 .5 8.038c0 3.706 2.747 6.909 6.391 7.453a.75.75 0 0 0 .219-1.483C4.197 13.571 2 11.006 2 8.037c0-1.654.652-3.197 1.835-4.347 1.173-1.138 2.695-1.745 4.35-1.688C11.39 2.1 14 4.934 14 8.322v.595c0 .764-.617 1.386-1.375 1.386s-1.375-.622-1.375-1.388V5.271c0-.414-.336-.722-.75-.722a.74.74 0 0 0-.726.633 3.313 3.313 0 0 0-2.024-.683c-1.93 0-3.5 1.57-3.5 3.472s1.57 3.472 3.5 3.472c.961 0 1.832-.39 2.465-1.019a2.868 2.868 0 0 0 2.41 1.323A2.884 2.884 0 0 0 15.5 8.861v-.539c0-4.191-3.263-7.725-7.269-7.818zM7.75 10c-1.103 0-2-.897-2-1.972 0-1.103.897-1.972 2-1.972s2 .897 2 1.972S8.853 10 7.75 10z" />
  </Icon>
);

export default AtRegularV6;
